import { render, staticRenderFns } from "./LectureScript.vue?vue&type=template&id=cd2275ac&"
import script from "./LectureScript.vue?vue&type=script&lang=js&"
export * from "./LectureScript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports